(function() {
  exports.HybridOption = (function() {
    HybridOption.prototype.id = null;

    HybridOption.prototype.isRefuge = false;

    function HybridOption(hybrid, hybridsTaffy, isRefuge, refuge_options) {
      var i, key, len, refuge, ro, temp_refuge_options, val;
      if (isRefuge == null) {
        isRefuge = false;
      }
      if (refuge_options == null) {
        refuge_options = null;
      }
      if (!((hybrid != null) && hybrid instanceof Object)) {
        return this.error('No hybrid given.', hybrid);
      }
      if ((hybrid.hybridID != null) && parseInt(hybrid.hybridID)) {
        this.id = parseInt(hybrid.hybridID);
      } else if ((hybrid.id != null) && parseInt(hybrid.id)) {
        this.id = parseInt(hybrid.id);
      } else if ((hybrid.hybrids_id != null) && parseInt(hybrid.hybrids_id)) {
        this.id = parseInt(hybrid.hybrids_id);
      } else if ((hybrid.refuge_hybrids_id != null) && parseInt(hybrid.refuge_hybrids_id)) {
        this.id = parseInt(hybrid.refuge_hybrids_id);
      } else {
        return this.error('No hybrid ID given.', hybrid);
      }
      if (!((hybridsTaffy != null) && hybridsTaffy instanceof Function)) {
        return this.error('No hybrids taffy table given.', hybridsTaffy);
      }
      hybrid = $.extend({}, hybrid, hybridsTaffy({
        id: this.id
      }).first());
      for (key in hybrid) {
        val = hybrid[key];
        if (key === 'id') {
          continue;
        }
        this[key] = val;
      }
      this.isRefuge = isRefuge;
      if (!this.isRefuge) {
        if ((hybrid.refuge_options != null) && hybrid.refuge_options instanceof Array) {
          temp_refuge_options = hybrid.refuge_options;
        } else if ((refuge_options != null) && refuge_options instanceof Array) {
          temp_refuge_options = refuge_options;
        } else {
          return this.error('No refuge options given.', hybrid);
        }
        this.refuge_options = [];
        for (i = 0, len = temp_refuge_options.length; i < len; i++) {
          refuge = temp_refuge_options[i];
          ro = new HybridOption(refuge, hybridsTaffy, true);
          if (ro != null) {
            this.refuge_options.push(ro);
          }
        }
      }
    }

    HybridOption.prototype.get = function() {
      var arr, i, key, len, obj, ref, ro, val;
      obj = {};
      ref = this;
      for (key in ref) {
        val = ref[key];
        if ((key === '__proto__' || key === 'id') || val instanceof Function) {
          continue;
        } else if (key === 'refuge_options') {
          arr = [];
          for (i = 0, len = val.length; i < len; i++) {
            ro = val[i];
            arr.push(ro.get());
          }
          obj['refuge_options'] = arr;
        } else {
          obj[key] = val;
        }
      }
      return obj;
    };

    HybridOption.prototype.error = function(msg, obj) {
      if (obj == null) {
        obj = null;
      }
      debugLog('Failed to create HybridOption object. ' + msg);
      if (obj != null) {
        debugLog(obj);
      }
      return null;
    };

    return HybridOption;

  })();

}).call(this);
